import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  type AlertDialogProps,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/modules/ui/components/alert-dialog/AlertDialog';

export interface ConfirmDeleteDialogProps extends AlertDialogProps {
  title?: string;
  description: string;
  trigger?: React.ReactNode;
  onCancel?: () => void;
  onDelete: () => void;
}

export const ConfirmDeleteDialog = ({
  title = 'Are you absolutely sure?',
  description,
  trigger,
  onCancel,
  onDelete,
  ...props
}: ConfirmDeleteDialogProps) => {
  return (
    <AlertDialog {...props}>
      {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}

      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={onDelete}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
